import { render, staticRenderFns } from "./CancelSuccess.vue?vue&type=template&id=974eb6bc&"
import script from "./CancelSuccess.vue?vue&type=script&lang=ts&"
export * from "./CancelSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./CancelSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports